import NodeTree from "../model/NodeTree";

const SetIdInTree = {
  Set(tree) {
    let newTree = [];
    tree.forEach((n) => {
      let node = new NodeTree(n);
      node.state = {
        expanded: true,
      };
      newTree.push(node);
    });
    return newTree;
  },
};

export default SetIdInTree;
